import { createActionGroup, emptyProps, props } from '@ngrx/store';

import {
  IDocumentLayoutsDocument,
  IDocumentLayoutSummary,
} from '../models/documents/document-layout.interface';

export const documentLayoutActions = createActionGroup({
  source: 'Document Layouts',
  events: {
    ['Load Layouts']: emptyProps(),
    ['Load Layouts Success']: props<{ layouts: IDocumentLayoutSummary[] }>(),
    ['Load Layouts Failure']: props<{ message: string }>(),
    ['Load Settings']: props<{ storeId: string }>(),
    ['Load Settings Success']: props<{ storeId: string; settings: IDocumentLayoutsDocument }>(),
    ['Load Settings Failure']: props<{ message: string }>(),
    ['Save Settings']: props<{ storeId: string; settings: IDocumentLayoutsDocument }>(),
    ['Save Settings Success']: props<{ storeId: string; settings: IDocumentLayoutsDocument }>(),
    ['Save Settings Failure']: props<{ message: string }>(),
    ['Preview']: props<{ accentColour: string; layoutKey: string; storeId: string }>(),
    ['Preview Success']: props<{ url: string }>(),
    ['Preview Failure']: props<{ message: string }>(),
    ['Clear Preview']: emptyProps(),
  },
});
